/*!
 *
 *  Web Starter Kit
 *  Copyright 2015 Google Inc. All rights reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *    https://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License
 *
 */
/* eslint-env browser */
(function () {
    'use strict';

    // Check to make sure service workers are supported in the current browser,
    // and that the current page is accessed from a secure origin. Using a
    // service worker from an insecure origin will trigger JS console errors. See
    // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
    var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
    );

    if ('serviceWorker' in navigator &&
        (window.location.protocol === 'https:' || isLocalhost)) {
        navigator.serviceWorker.register('service-worker.js')
            .then(function (registration) {
                // updatefound is fired if service-worker.js changes.
                registration.onupdatefound = function () {
                    // updatefound is also fired the very first time the SW is installed,
                    // and there's no need to prompt for a reload at that point.
                    // So check here to see if the page is already controlled,
                    // i.e. whether there's an existing service worker.
                    if (navigator.serviceWorker.controller) {
                        // The updatefound event implies that registration.installing is set:
                        // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
                        var installingWorker = registration.installing;

                        installingWorker.onstatechange = function () {
                            switch (installingWorker.state) {
                                case 'installed':
                                    // At this point, the old content will have been purged and the
                                    // fresh content will have been added to the cache.
                                    // It's the perfect time to display a "New content is
                                    // available; please refresh." message in the page's interface.
                                    break;

                                case 'redundant':
                                    throw new Error('The installing ' +
                                        'service worker became redundant.');

                                default:
                                // Ignore
                            }
                        };
                    }
                };
            }).catch(function (e) {
                console.error('Error during service worker registration:', e);
            });
    }

    // Your custom JavaScript goes here


    // document.querySelector('.button.round.orange.glossy').addEventListener('click', () => {
    //     toggleFullScreen();
    //     document.querySelector('.mask').classList.remove('stop');
    //     document.querySelector('.ball').classList.remove('hidden');
    //     document.querySelector('.ball1').classList.remove('hidden');
    //     document.querySelector('.button.round.orange.glossy').classList.add('hidden');

    // });
    function skipAnimation() {
        document.querySelector('.mask').classList.add('done');
        document.querySelector('.android-header').classList.add('done');
        document.querySelector('.uae-background').classList.add('done');
        document.querySelectorAll('.android-more-section .mdl-cell .button').forEach((btn) => {
            btn.classList.add('done');
        });
        document.querySelector('.uae-text').classList.add('done');
        document.querySelector('.android-content.mdl-layout__content.uae-body').classList.add('done');
    }
    if (sessionStorage.getItem('visited') === 'true') {
        skipAnimation();
    } else {
        setTimeout(() => {
            document.querySelector('.mask').classList.add('fade-out');
            document.querySelector('.android-header').classList.add('fade-in-header');
        }, 3000);
        document.querySelector('.mask').addEventListener('animationend', () => {
            document.querySelector('.uae-background').classList.add('fade-in');
        });
        document.querySelector('.uae-background').addEventListener('animationend', () => {
            document.querySelectorAll('.android-more-section .mdl-cell .button').forEach((btn) => {
                btn.classList.add('fade-in-button');
            });
            document.querySelector('.uae-text').classList.add('fade-in-text');
        });
        document.querySelector('.uae-text').addEventListener('animationend', () => {
            document.querySelector('.android-content.mdl-layout__content.uae-body').classList.add('slide-up');
        });
        sessionStorage.setItem('visited', true);
    }

    function toggleFullScreen() {
        if (!document.fullscreenElement &&    // alternative standard method
            !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {  // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }

    document.addEventListener("keydown", function (e) {
        if (e.key === 'f') {
            toggleFullScreen();
        }
    }, false);
    // webkitAnimationEnd
})();
